/* ===== Landing navigation config =====
   Single source of truth for the public site's tabs: the top navbar, the
   footer links, the "Enroll Your Store" CTA and the route table in
   routing/Routing.js all read from here, so a tab is added (or its URL
   changed) in exactly one place and the active-tab highlight follows for
   free. */

export const DEFAULT_LANDING_TAB = "home";

/* Tabs rendered in the top navigation bar, in display order. */
export const LANDING_NAV_ITEMS = [
  { key: "retail-pos", label: "Retail POS", path: "/retail-pos" },
  {
    key: "payment-processing",
    label: "Payment Processing",
    path: "/payment-processing",
  },
  { key: "industries", label: "Industries", path: "/industries" },
  { key: "loss-prevention", label: "Loss Prevention", path: "/loss-prevention" },
  { key: "agents", label: "Agents", path: "/agents" },
  { key: "contact", label: "Contact", path: "/contact" },
];

/* Reachable from the brand mark, the footer and the CTA, but not shown as a
   top-level tab. */
export const LANDING_HIDDEN_ITEMS = [
  { key: DEFAULT_LANDING_TAB, label: "Home", path: "/" },
  {
    key: "merchants",
    label: "Enroll Your Store",
    path: "/merchant-application",
  },
];

/* Every landing URL that has to exist in the router. */
export const LANDING_ROUTES = [...LANDING_HIDDEN_ITEMS, ...LANDING_NAV_ITEMS];

/* "/Retail-POS/" and "/retail-pos" are the same tab. */
const normalizePath = (pathname = "") => {
  const trimmed = String(pathname).toLowerCase().replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
};

/* Route -> tab. Falls back to the home tab so an unmapped URL still renders
   the landing page rather than a blank section. */
export const getTabFromPath = (pathname) => {
  const path = normalizePath(pathname);
  const match = LANDING_ROUTES.find((item) => normalizePath(item.path) === path);
  return match ? match.key : DEFAULT_LANDING_TAB;
};

/* Tab -> route, for the nav, the footer and the CTA. */
export const getPathForTab = (tabKey) => {
  const match = LANDING_ROUTES.find((item) => item.key === tabKey);
  return match ? match.path : "/";
};
